import { IMG_URL } from '../configs/app-global';
import placeholder from '../assets/images/placeholder.jpeg';

export default function getImage(url) {
  if (!url) {
    return placeholder;
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return IMG_URL + url;
}
